<template>
  <span
    aria-live="assertive"
    role="alert"
    :class="['timed-badge', badgeType, { '-visible': notificationVisible }]"
    :aria-hidden="!notificationVisible"
  >
    {{ message }}
  </span>
</template>

<script setup lang="ts">
/**
 * Up to parent component to v-if this component if you need the notification
 * to show multiple times.
 *
 * It is assertive / alert as it is timed and should be read by screen readers before
 * fading away (just like visual usuals see quickly).
 */
import { onMounted, ref } from 'vue'

/** PROPS */
const props = withDefaults(
  defineProps<{
    message: string
    badgeType?: 'success' | 'error'
    displayMs?: number
  }>(),
  {
    badgeType: 'success',
    displayMs: 2000,
  },
)

/** EMITS */
const emit = defineEmits(['close'])

/** STATE */
const notificationVisible = ref(false)

onMounted(() => {
  // give time for animation to show, otherwise it is instant
  setTimeout(() => {
    notificationVisible.value = true
  }, 25)

  // text is fully visible
  setTimeout(() => {
    notificationVisible.value = false

    // css takes 1s for fade out currently, let animation complete
    setTimeout(() => {
      emit('close')
    }, 1000)
  }, props.displayMs)
})
</script>
